import React, { useEffect, useRef, useState } from "react";

import ItemCard from "./ItemCard";
import '../assets/styles/ItemCarousel.css'

export default function ItemCarousel(props) {

    const removeCarouselItem = (assetId) => {
        if (props.itemOwner === 'user') {
            let targetItem = props.offeringItems.find(item => item.assetId === assetId)
            let newOfferingItems = props.offeringItems.filter(item => item.assetId !== assetId)
            props.setOfferingItems(newOfferingItems)
            props.setUserAvailableItems([targetItem, ...props.userAvailableItems]);
        } else if (props.itemOwner === 'bot') {
            let targetItem = props.askingItems.find(item => item.assetId === assetId)
            let newAskingItems = props.askingItems.filter(item => item.assetId !== assetId)
            props.setAskingItems(newAskingItems)
            props.setBotAvailableItems([targetItem, ...props.botAvailableItems])
        }

    }

    return (
        <div className="item-carousel d-flex align-items-center">
            {props.itemOwner.match('user') ?
                Array.isArray(props.offeringItems) && props.offeringItems.map((item) => (
                    <ItemCard
                        key={item.assetId}
                        setItemInfoModalData={props.setItemInfoModalData}
                        setItemInfoModalVisible={props.setItemInfoModalVisible}
                        itemData={item}
                        onClick={() => removeCarouselItem(item.assetId)}
                    />
                ))
                :
                Array.isArray(props.askingItems) && props.askingItems.map((item) => (
                    <ItemCard
                        key={item.assetId}
                        setItemInfoModalData={props.setItemInfoModalData}
                        setItemInfoModalVisible={props.setItemInfoModalVisible}
                        itemData={item}
                        onClick={() => removeCarouselItem(item.assetId)}
                    />
                ))
            }
        </div>
    )
}